import { useTranslation } from '@gimlite/common';
import { observer } from 'mobx-react-lite';
import {
  CredentialCard,
  CredentialCardType,
  CredentialMini,
} from '../../components/credential/credential.component';
import { CredentialType } from '../../common/mapper/credential.mapper';
import { useStoreUIV1 } from '@gimlite/ui-v1';

export class TCSCredentialStatic {
  static info: CredentialType.Static<TCSCredentialCardType.Data> = {
    name: 'TCS',
    icon: 'partnerTCS',
    backgroundColor: { light: '#ffec01', dark: '#ffec01' },
    color: { light: '#333333', dark: '#333333' },
    category: 'RFID',
    primaryValue: 'externalId',
  };
}

export declare namespace TCSCredentialMiniType {
  type Props = {
    data?: {
      value?: string | null;
    };
  };
}

export const TCSCredentialMini = observer(
  ({ data: { value } = {} }: TCSCredentialMiniType.Props) => {
    const { ThemeStore } = useStoreUIV1();

    return (
      <CredentialMini
        data={{ text: value }}
        config={{
          icon: TCSCredentialStatic.info.icon,
          backgroundColor:
            TCSCredentialStatic.info.backgroundColor[ThemeStore.theme],
          color: TCSCredentialStatic.info.color[ThemeStore.theme],
        }}
      />
    );
  },
);

export declare namespace TCSCredentialCardType {
  type Props = {
    handleEvent?: {
      event?: CredentialCardType.HandleEvent.Event['function'];
    };
    data: TCSCredentialCardType.Data;
    config?: {
      isActive?: boolean;
    };
  };

  type Data = {
    _id: string;
    externalId: string;
  };
}

export const TCSCredentialCard = observer(
  ({
    handleEvent: { event } = {},
    data: { _id, externalId },
    config: { isActive = true } = {},
  }: TCSCredentialCardType.Props) => {
    const { t, lang } = useTranslation();
    const { ThemeStore } = useStoreUIV1();

    return (
      <CredentialCard.Context.Consumer>
        {({ place, edit }) => (
          <CredentialCard
            handleEvent={{ event, edit }}
            data={{
              name: TCSCredentialStatic.info.name,
              info: [
                {
                  key: 'externalId',
                  label: t('externalId'),
                  value: externalId,
                  _id,
                },
              ],
              category: TCSCredentialStatic.info.category,
              primaryValue: TCSCredentialStatic.info.primaryValue,
            }}
            config={{
              icon: TCSCredentialStatic.info.icon,
              backgroundColor:
                TCSCredentialStatic.info.backgroundColor[ThemeStore.theme],
              color: TCSCredentialStatic.info.color[ThemeStore.theme],
              disabled: !isActive,
              action:
                place === 'contractDisabled'
                  ? []
                  : !isActive
                    ? [{ label: t('import'), value: 'import' }]
                    : place === 'wizardContractExist'
                      ? [{ label: t('delete'), value: 'delete' }]
                      : place === 'wizardNewContract'
                        ? [{ label: t('delete'), value: 'delete' }]
                        : place === 'contract'
                          ? [{ label: t('delete'), value: 'delete' }]
                          : [],
            }}
          />
        )}
      </CredentialCard.Context.Consumer>
    );
  },
);
